import { Create, Edit } from 'react-admin';
import list from './list';
import show from './show';
import { FormFields } from './components';
import { enforceGroupId } from '../../util';

const create = () => (
	<Create record={enforceGroupId()}>
		{FormFields}
	</Create>
);

const edit = () => (
	<Edit record={enforceGroupId()}>
		{FormFields}
	</Edit>
);


export const Orb = {
	list,
	edit,
	show,
	create
};

export default Orb;